import { createElement } from "react";
import { renderToStaticMarkup } from "react-dom/server";

import { AlertsIcon } from "../../icons/AlertsIcon";
import { CandlestickChartIcon } from "../../icons/CandlestickChartIcon";
import { ChevronRightIcon } from "../../icons/ChevronRightIcon";
import { ColumnWidthsIcon } from "../../icons/ColumnWidthsIcon";
import { CopyIcon } from "../../icons/CopyIcon";
import { DeleteIcon } from "../../icons/DeleteIcon";
import { FileExportIcon } from "../../icons/FileExportIcon";
import { FileMagnifyingGlassIcon } from "../../icons/FileMagnifyingGlassIcon";
import { FunctionIcon } from "../../icons/FunctionIcon";
import { InputPipeIcon } from "../../icons/InputPipeIcon";
import { LineChartIcon } from "../../icons/LineChartIcon";
import { LineColumnsIcon } from "../../icons/LineColumnsIcon";
import { PaletteIcon } from "../../icons/PaletteIcon";

import { faLineHeight, faCheck, faKeyboard, faDiagramCells, faPlus } from "@fortawesome/pro-solid-svg-icons";
import { faGear } from "@fortawesome/pro-regular-svg-icons";
import { library, icon } from "@fortawesome/fontawesome-svg-core";

library.add([faLineHeight, faCheck, faKeyboard, faGear, faDiagramCells, faPlus]);

const faIcons = {
  header: icon({ prefix: "fas", iconName: "line-height" }),
  check: icon({ prefix: "fas", iconName: "check" }),
  keyboard: icon({ prefix: "fas", iconName: "keyboard" }),
  settings: icon({ prefix: "far", iconName: "gear" }),
  type: icon({ prefix: "fas", iconName: "diagram-cells" }),
  add: icon({ prefix: "fas", iconName: "plus" }),
};

const iconComponents = {
  field: InputPipeIcon,
  column: LineColumnsIcon,
  remove: DeleteIcon,
  width: ColumnWidthsIcon,
  format: PaletteIcon,
  alerts: AlertsIcon,
  copy: CopyIcon,
  export: FileExportIcon,
  details: FileMagnifyingGlassIcon,
  function: FunctionIcon,
  chevron: ChevronRightIcon,
  chartCandlestick: CandlestickChartIcon,
  barChart: LineChartIcon,
  lineChart: LineChartIcon,
} as const;

type IconName = keyof typeof iconComponents | keyof typeof faIcons;

export const getIcon = (iconName: IconName, color?: string): string => {
  if (iconName in iconComponents) {
    const IconComponent = iconComponents[iconName as keyof typeof iconComponents];
    const html = renderToStaticMarkup(createElement(IconComponent));
    if (color) {
      return html.replace(/currentColor/g, color);
    }
    return html;
  }

  if (iconName in faIcons) {
    const faIcon = faIcons[iconName as keyof typeof faIcons];
    if (color) {
      return faIcon.html.join().replace("currentColor", color);
    }
    return faIcon.html.join();
  }

  console.warn(`Icon "${iconName}" not found`);
  return "";
};
